import { useEffect, useState } from 'react';
import { FiEdit } from 'react-icons/fi';
import EditProfile from './EditProfile';
import { Badge } from 'react-bootstrap';
import { useGetProfileData } from '../apiEndpoints/exhibitorApiEndpoints';
import SpaceRequirements from './SpaceRequirement/SpaceRequirements';
import { useSearchParams } from 'react-router-dom';

const ProfileHomepage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [toggle, setToggle] = useState(false);
  const { data } = useGetProfileData();
  useEffect(() => {
    setSearchParams({ isSpace: 'available' });
  }, []);
  return (
    <>
      {toggle ? (
        <div className='profile-right-side px-3 py-3 mb-2'>
          <div className='d-flex align-items-center justify-content-between'>
            <h5>Edit profile information</h5>
            <div
              onClick={() => setToggle(false)}
              className='d-flex  align-items-center gap-1 pointer'
              style={{
                backgroundColor: '#1a7f37',
                color: 'white',
                padding: '5px 7px',
                borderRadius: '5px',
              }}
            >
              <p>Back</p>
            </div>
          </div>
        </div>
      ) : (
        <div className='profile-right-side px-3 py-3 mb-2'>
          <div className='d-flex align-items-center justify-content-between'>
            <h5>Basic Information</h5>
            <div
              onClick={() => setToggle(true)}
              className='d-flex  align-items-center gap-1 pointer'
              style={{
                backgroundColor: '#1a7f37',
                color: 'white',
                padding: '5px 7px',
                borderRadius: '5px',
              }}
            >
              <p>Edit</p> <FiEdit />
            </div>
          </div>
        </div>
      )}

      {toggle ? (
        <EditProfile setToggle={setToggle} />
      ) : (
        <div>
          <div className='profile-right-side px-3 py-3'>
            <div className='profile-right-info ps-2'>
              <div className='fs-4 mb-3'>Company Information</div>
              <ul>
                <li>
                  <span>Company name</span> :{' '}
                  <p>{data?.data?.user_fair_member_company_name}</p>
                </li>
                <li>
                  <span>Company Email</span> :{' '}
                  <p>{data?.data?.user_fair_member_company_email}</p>
                </li>

                <li>
                  <span>Phone</span> :{' '}
                  <p>{data?.data?.user_fair_member_company_telephone}</p>
                </li>
                <li>
                  <span>Web address</span> :{' '}
                  <p>{data?.data?.user_fair_member_company_website}</p>
                </li>
                <li>
                  <span>Address</span> :{' '}
                  <p>{data?.data?.user_fair_member_company_address} </p>
                </li>
                <li>
                  <span>City</span> :{' '}
                  <p>{data?.data?.user_fair_member_company_city}</p>
                </li>
                <li>
                  <span>Zip</span> :{' '}
                  <p>{data?.data?.user_fair_member_company_zip}</p>
                </li>
                <li>
                  <span>Status</span> :{' '}
                  {data?.data?.user_fair_member_status === 'approved' ? (
                    <Badge
                      style={{ width: '90px' }}
                      className='ms-1'
                      bg='success'
                    >
                      Approved
                    </Badge>
                  ) : (
                    <Badge
                      style={{ width: '90px' }}
                      className='ms-1'
                      bg='danger'
                    >
                      Pending
                    </Badge>
                  )}
                </li>
              </ul>
            </div>
          </div>

          <div className='profile-right-side px-3 py-3 mt-4 '>
            <h5>Contact person</h5>
            <div className='profile-right-info pt-3 ps-2'>
              <ul>
                <li>
                  <span>Contact name</span> :{' '}
                  <p>{data?.data?.user_fair_member_contact_name}</p>
                </li>
                <li>
                  <span>Designation</span> :{' '}
                  <p>{data?.data?.user_fair_member_contact_designation}</p>
                </li>
                <li>
                  <span>Mobile</span> :{' '}
                  <p>{data?.data?.user_fair_member_contact_number}</p>
                </li>
                <li>
                  <span>Email</span> :{' '}
                  <p>{data?.data?.user_fair_member_contact_email}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      <div className='mt-3'>
        <SpaceRequirements />
      </div>
    </>
  );
};

export default ProfileHomepage;
